

import Vue from 'vue'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'


import store from './store'
import axios from './axios'
import router from './router'
import App from './App'
import Vuex from 'vuex'
import VueAMap from 'vue-amap'
import 'lib-flexible'

Vue.use(LoadingPlugin)
Vue.use(Vuex)
Vue.use(VueAMap)

VueAMap.initAMapApiLoader({

key: '1f5bb764839780ea3e025d33cd657585',

plugin: ['Autocomplete', 'PlaceSearch', 'Scale', 'OverView', 'ToolBar', 'MapType', 'PolyEditor', 'CircleEditor', 'Geolocation', 'Geocoder'],
v: '1.4.4'
})




Vue.config.productionTip = false


import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import ossResize from '@/filters/oss-resize'
Vue.filter('ossResize', ossResize)


import formatSize from '@/filters/format-size'
Vue.filter('formatSize', formatSize)


import camptype from '@/filters/camp-type'
Vue.filter('camptype', camptype)


import distance from '@/filters/distance'
Vue.filter('distance', distance)


import searchtype from '@/filters/serach-type'
Vue.filter('searchtype', searchtype)


var VueTouch = require('vue-touch')
Vue.use(VueTouch, {name: 'v-touch'})


Vue.prototype.axios = axios
/* eslint-disable no-new */
new Vue({
router,
store,
axios,
render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js